import SideBarContainer from './SideBarContainer'

export default SideBarContainer



// WEBPACK FOOTER //
// ./src/containers/SideBarContainer/index.js